module.exports = __webpack_public_path__ + "static/img/limit-reward-bg.834a463.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/limit-reward-bg.png
// module id = 3w6v
// module chunks = 213